/**
 * INFINITY LIFE 2.0 — Asaas Checkout & Customer Enrollment Modal
 */

import { store } from '../state.js';
import { showToast } from '../api.js';

let selectedPlan = {
  id: 'annual',
  name: 'Acesso Anual VIP (Mais Popular)',
  price: 'R$ 197,00',
  period: '/ano (ou 12x de R$ 19,70)',
};

let checkoutState = {
  isOpen: false,
  step: 'form', // 'form' | 'success'
  customer: {
    name: '',
    email: '',
    phone: '',
    cpf: '',
  },
};

export function openCheckoutModal(plan) {
  if (plan) selectedPlan = plan;
  checkoutState.isOpen = true;
  checkoutState.step = 'form';
  window.dispatchEvent(new CustomEvent('infinity:render'));
}

export function closeCheckoutModal() {
  checkoutState.isOpen = false;
  window.dispatchEvent(new CustomEvent('infinity:render'));
}

export function renderCheckoutModal() {
  if (!checkoutState.isOpen) {
    return `<div id="checkout-modal-container"></div>`;
  }

  const { customer, step } = checkoutState;

  return `
    <div class="modal-overlay open" id="checkout-modal-overlay">
      <div class="modal-card" style="max-width: 520px;">
        <div class="modal-header">
          <div style="display: flex; align-items: center; gap: 8px;">
            <span style="font-size: 1.3rem;">💳</span>
            <h2 class="modal-title">Desbloquear o Infinity Life</h2>
          </div>
          <button class="btn-close" id="btn-close-checkout-modal">✕</button>
        </div>

        ${step === 'form' ? renderCheckoutForm(customer) : renderCheckoutSuccess()}
      </div>
    </div>
  `;
}

function renderCheckoutForm(customer) {
  return `
    <div style="padding-top: 6px;">
      <!-- Selected Plan Summary Card -->
      <div style="background: var(--bg-tertiary); border: 1px solid var(--border-subtle); border-radius: var(--radius-md); padding: 14px 18px; margin-bottom: 20px; display: flex; align-items: center; justify-content: space-between;">
        <div>
          <div style="font-size: 0.78rem; text-transform: uppercase; color: var(--text-muted); font-weight: 700;">Plano Selecionado</div>
          <div style="font-weight: 700; color: var(--text-primary); font-size: 1rem; margin-top: 2px;">${selectedPlan.name}</div>
        </div>
        <div style="text-align: right;">
          <div style="font-weight: 800; font-size: 1.25rem; color: var(--emerald-accent);">${selectedPlan.price}</div>
          <div style="font-size: 0.72rem; color: var(--text-muted);">${selectedPlan.period}</div>
        </div>
      </div>

      <form id="checkout-form">
        <div class="form-group" style="margin-bottom: 14px;">
          <label class="form-label" style="font-size: 0.85rem; font-weight: 600;">Seu Nome Completo *</label>
          <input type="text" id="chk-name" class="form-input" placeholder="Ex: Nícolas Silva" required value="${escapeHtml(customer.name)}" />
        </div>

        <div class="form-group" style="margin-bottom: 14px;">
          <label class="form-label" style="font-size: 0.85rem; font-weight: 600;">Seu Melhor E-mail (Será seu Login) *</label>
          <input type="email" id="chk-email" class="form-input" placeholder="Ex: seuemail@gmail.com" required value="${escapeHtml(customer.email)}" />
          <div style="font-size: 0.72rem; color: var(--text-muted); margin-top: 4px;">Este e-mail terá acesso instantâneo liberado na plataforma.</div>
        </div>

        <div class="form-row" style="display: grid; grid-template-columns: 1fr 1fr; gap: 12px; margin-bottom: 20px;">
          <div class="form-group">
            <label class="form-label" style="font-size: 0.85rem; font-weight: 600;">WhatsApp com DDD *</label>
            <input type="tel" id="chk-phone" class="form-input" placeholder="(11) 99999-9999" required value="${escapeHtml(customer.phone)}" />
          </div>

          <div class="form-group">
            <label class="form-label" style="font-size: 0.85rem; font-weight: 600;">CPF / CNPJ *</label>
            <input type="text" id="chk-cpf" class="form-input" placeholder="000.000.000-00" required value="${escapeHtml(customer.cpf)}" />
          </div>
        </div>

        <!-- Asaas Notice -->
        <div style="background: rgba(16, 185, 129, 0.08); border: 1px solid rgba(16, 185, 129, 0.2); border-radius: var(--radius-sm); padding: 12px; margin-bottom: 20px; display: flex; align-items: flex-start; gap: 10px;">
          <span style="font-size: 1.2rem;">🔒</span>
          <div style="font-size: 0.8rem; color: var(--text-secondary); line-height: 1.4;">
            <strong>Pagamento 100% Protegido pelo Asaas:</strong> Seus dados são criptografados. Liberação imediata para PIX ou Cartão de Crédito.
          </div>
        </div>

        <button type="submit" class="btn-primary" style="width: 100%; justify-content: center; padding: 14px; font-size: 1.05rem; font-weight: 700;">
          <span>Continuar para Pagamento via Asaas →</span>
        </button>
      </form>
    </div>
  `;
}

function renderCheckoutSuccess() {
  const email = checkoutState.customer.email;

  return `
    <div style="text-align: center; padding: 20px 0;">
      <div style="font-size: 3rem; margin-bottom: 12px;">🎉</div>
      <h3 style="font-size: 1.3rem; font-weight: 800; margin-bottom: 8px;">Quase lá! Conclua no Asaas</h3>
      <p style="font-size: 0.9rem; color: var(--text-secondary); line-height: 1.6; margin-bottom: 24px;">
        Cadastrado com sucesso para <strong>${escapeHtml(email)}</strong>. Você pode pagar via PIX ou Cartão pelo gateway seguro do Asaas.
      </p>

      <!-- Simulated PIX QR Code for preview & direct testing -->
      <div style="background: var(--bg-tertiary); border: 1px solid var(--border-subtle); border-radius: var(--radius-md); padding: 20px; margin-bottom: 24px; text-align: center;">
        <div style="font-size: 0.8rem; color: var(--text-muted); text-transform: uppercase; font-weight: 700; margin-bottom: 10px;">
          Ambiente de Demonstração Asaas
        </div>
        <div style="font-size: 1.1rem; font-weight: 700; color: var(--emerald-accent); margin-bottom: 12px;">
          Total a Pagar: ${selectedPlan.price}
        </div>
        <p style="font-size: 0.82rem; color: var(--text-secondary); margin-bottom: 16px;">
          O link oficial do Asaas será acionado em produção assim que configurado pelo administrador.
        </p>
        <button class="btn-primary" id="btn-simulate-asaas-paid" style="width: 100%; justify-content: center; padding: 12px;">
          <span>⚡ Simular Confirmação Asaas & Entrar na Plataforma</span>
        </button>
      </div>

      <button class="btn-secondary" id="btn-back-checkout" style="width: 100%; justify-content: center;">
        Voltar para a Página Inicial
      </button>
    </div>
  `;
}

function escapeHtml(str) {
  if (!str) return '';
  const div = document.createElement('div');
  div.textContent = str;
  return div.innerHTML;
}

export function attachCheckoutModalEvents(container) {
  const closeBtn = container.querySelector('#btn-close-checkout-modal');
  const overlay = container.querySelector('#checkout-modal-overlay');

  if (closeBtn) closeBtn.addEventListener('click', closeCheckoutModal);
  if (overlay) {
    overlay.addEventListener('click', (e) => {
      if (e.target === overlay) closeCheckoutModal();
    });
  }

  const form = container.querySelector('#checkout-form');
  if (form) {
    form.addEventListener('submit', (e) => {
      e.preventDefault();
      checkoutState.customer = {
        name: container.querySelector('#chk-name').value.trim(),
        email: container.querySelector('#chk-email').value.trim(),
        phone: container.querySelector('#chk-phone').value.trim(),
        cpf: container.querySelector('#chk-cpf').value.trim(),
      };

      // Check if Asaas payment URL is configured in store / settings
      const settings = store.get().settings || {};
      const asaasUrl = settings.asaas_payment_url;

      if (asaasUrl && asaasUrl.startsWith('http')) {
        showToast('Redirecionando para o Asaas Checkout...', 'info');
        window.open(asaasUrl, '_blank');
      }

      checkoutState.step = 'success';
      window.dispatchEvent(new CustomEvent('infinity:render'));
    });
  }

  // Simulated confirmation button
  const simulateBtn = container.querySelector('#btn-simulate-asaas-paid');
  if (simulateBtn) {
    simulateBtn.addEventListener('click', () => {
      const email = checkoutState.customer.email || 'novo_membro@infinitylife.com';
      const name = checkoutState.customer.name || 'Membro VIP';

      // Automatically sign in as authorized user
      store.updateUser({
        id: Date.now(),
        name,
        email,
        role: 'user',
        is_owner: false,
        preferences: { theme: 'dark' },
      });

      showToast(`Acesso liberado com sucesso para ${email}!`, 'success');
      closeCheckoutModal();
      store.setView('my-day');
    });
  }

  const backBtn = container.querySelector('#btn-back-checkout');
  if (backBtn) {
    backBtn.addEventListener('click', closeCheckoutModal);
  }
}
